(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["c-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const trigger = document.querySelector('.js-filter-trigger');
    if (trigger) {
      trigger.addEventListener('click', function() {
        document.querySelector('.js-filter').classList.toggle('is-open');
      });
    }

    // Make sort checkboxes behave like a single-choice (radio) group and auto-submit on change
    const sortContainer = document.querySelector('.c-facet--sort');
    if (sortContainer) {
      const form = sortContainer.closest('form');
      const sortChecks = sortContainer.querySelectorAll('input[type="checkbox"][name="sort_by"]');
      sortChecks.forEach((cb) => {
        cb.addEventListener('change', () => {
          if (cb.checked) {
            // Uncheck others
            sortChecks.forEach((other) => {
              if (other !== cb) other.checked = false;
            });
            if (form) form.submit();
          } else {
            // If none checked, submit to clear sorting
            const anyChecked = Array.from(sortChecks).some((x) => x.checked);
            if (!anyChecked && form) form.submit();
          }
        });
      });
    }

    const form = document.querySelector('.c-filter__form');
    if (form) {
      const filterChecks = form.querySelectorAll('.c-facet--filter input[type="checkbox"]');
      filterChecks.forEach((cb) => {
        cb.addEventListener('change', () => {
          form.submit();
        });
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
